import React,{useState,useEffect} from 'react'
import { URL } from '../../Helper/helper'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { invokeSquad } from '../../ServiceCalls/ApiCalls';
import './Squad.css'


function SquadComponent() {

    const navigate = useNavigate()

    const[squad,setSquad] = useState([])
    const[squadName,setSquadName] = useState('')
    const[squadYear,setSquadYear] = useState('')
    const[squadid,setSquadId] = useState('')
    const[rowid,setRowId]= useState('')
    const[status,setStatus]=useState(false)
    const[isLoading,setIsLoading] = useState(true)
    const[isRefreshing,setIsRefreshing] = useState(false)
    const[createSquad,setCreateSquad] = useState({
        squad_name:'',
        squad_year:''
    })

    useEffect(() =>{
        if(!localStorage.getItem('user')){
            navigate('/')
        }
        async function GetData(){
            setIsLoading(true);
            try {
                const squad_list = await invokeSquad()
                setSquad(squad_list)
            } catch (error) {
                console.error('Error fetching squad:', error);
                toast.error('Failed to load squad', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            } finally {
                setIsLoading(false);
            }
        }
    
        GetData()
    },[])

    const refreshSquad = async () => {
        setIsRefreshing(true);
        try {
          const squad_list = await invokeSquad()
          setSquad(squad_list)
          
          toast.success('Squad refreshed successfully!', {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } catch (error) {
          console.error('Error refreshing squad:', error);
          toast.error('Failed to refresh squad', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } finally {
          setIsRefreshing(false);
        }
    };

    const handleAddSquad = (e) => {
        const{name,value} = e.target;
        setCreateSquad({...createSquad,[name]:value})
    }

    const options = (method = "GET",body) =>{
        return {
            method,
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(body)
        }
    }

    const handleSquadChange = e =>{
        const{name,value} = e.target;

        if(name === 'squad_name'){
            setSquadName(value)
        }
        if(name === 'squad_year'){
            setSquadYear(value)
        }
    }
    const reset = (e) => {
        e.preventDefault()
        setCreateSquad({
            squad_name:'',
            squad_year:''
        })
    }
    const handleEditSquad = (s,rid) => {
        setSquadName(s.squad_name)
        setSquadYear(s.squad_year)
        setSquadId(s._id)
        setRowId(rid)
        setStatus(false)
    }

    const handleSubmitSquad = async(e) => {
        e.preventDefault()

        try {
            const add_squad_response = await fetch(`${URL}` + '/squad/addsquad',options("POST",createSquad));
            const squad_data = await add_squad_response.json();

            if(add_squad_response.ok){
                //alert('Term Dates Added !!')
                setSquad([...squad,squad_data])
                toast.success('🦄 Wow Squad Added!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                reset()
            }
            else{
                //alert('Add TermDates Failed...')
                toast.error('🦄 OOps Add Squad Failed!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleUpdateSquad = async() => {
        try {
            const update_squad_response = await fetch(`${URL}` + '/squad/'+`${squadid}`,options("PATCH",{squad_name:squadName,squad_year:squadYear}));

            if(update_squad_response.ok){
                const update_squad_status = await update_squad_response.json();
                const dataUpdate = [...squad]
                dataUpdate[rowid] = update_squad_status;
                setSquad([...dataUpdate])
                setStatus(true)
                //toggleRow(rowid)
                toast.success('🦄 Wow Squad Updated!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
            }
            else{
               // alert('Update Failed')
               toast.error('🦄 OOps Squad Update Failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
    
        } catch (error) {
            console.log(error)
        }
    }
    const deleteSquad = async(id,rid) => {

        if(!window.confirm('Are you Sure You wanna Delete the Record at Row-No - '+`${rid+1}`))
            return;

        try{
            const delete_squad_response = await fetch(`${URL}` + '/squad/'+`${id}`, options("DELETE"));
            if(delete_squad_response.ok){
               // alert(`TermDate at ${rowid+1}  is Deleted !!`)
                const dataDelete = [...squad];
                dataDelete.splice(rid,1)
                setSquad([...dataDelete])
                toast.success('🦄 Wow Squad Deleted!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
    
            }
            else{
                toast.error('🦄 OOps Squad Del Failed!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        }catch(err){
            console.log(err)
        }
      }
  return (
    <div className="admin-panel">
        <div className='container admin-container'>
            <div className="row mt-5">
              <div className="col-md-12 col-sm-12">
                <div className="failed-bookings-header d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h3 className="mb-1">
                      <i className="fa fa-users text-warning me-2"></i>
                      Manage Squad ({squad.length})
                    </h3>
                    <p className="text-muted">Add new squad and manage existing squad records</p>
                  </div>
                  <div className="failed-bookings-actions">
                    <button 
                      className="btn btn-outline-secondary me-2"
                      onClick={refreshSquad}
                      disabled={isRefreshing}
                    >
                      {isRefreshing ? (
                        <>
                          <i className="fa fa-spinner fa-spin me-1"></i>
                          Refreshing...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-refresh me-1"></i>
                          Refresh
                        </>
                      )}
                    </button>
                    <button 
                      className="btn btn-primary"
                      onClick={() => navigate('/user')}
                    >
                      <i className="fa fa-arrow-left me-1"></i>
                      Back to Dashboard
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Add Squad Section */}
            <div className="row mb-5">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="mb-0">
                    <i className="fa fa-plus-circle text-primary me-2"></i>
                    Add New Squad
                  </h4>
                </div>
                <div className="row">
                  <div className="col-md-8 col-lg-6">
                    <form onSubmit={handleSubmitSquad}>
                      <div className="mb-3">
                          <label htmlFor="name" className="form-label">Squad Name</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            id="name" 
                            name="squad_name"
                            value={createSquad.squad_name}
                            onChange={e => handleAddSquad(e)} 
                            required
                            placeholder="Enter Squad Name" autoComplete='off'/>
                      </div>
                      <div className="mb-3">
                          <label htmlFor="squad_year" className="form-label">Squad Year</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            id="squad_year" 
                            name="squad_year"
                            value={createSquad.squad_year} 
                            onChange={e => handleAddSquad(e)} 
                            required
                            placeholder="Enter Squad Year" autoComplete='off'/>
                      </div>
                      <div className="d-flex gap-2">
                        <button 
                          type="submit" 
                          className="btn btn-primary">
                          <i className="fa fa-plus me-1"></i>
                          Add Squad
                        </button>
                        <button 
                          onClick={e => reset(e)}
                          className="btn btn-outline-secondary">
                          <i className="fa fa-refresh me-1"></i>
                          Reset
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            {/* Existing Squad Section */}
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="mb-0">
                    <i className="fa fa-list text-warning me-2"></i>
                    Existing Squad
                  </h4>
                </div>
                
                {isLoading ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="text-center">
                      <div className="spinner-border text-warning" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3 text-muted">Loading squad...</p>
                    </div>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className='table table-bordered table-hover'>
                        <thead className="table-warning text-center">
                            <tr>
                                <th className='text-center'>S.No</th>
                                <th className='text-center'>Squad Name</th>
                                <th className='text-center'>Year</th>
                                <th className='text-center'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                squad.length > 0 ?
                                squad.map((s,idx) =><tr key={idx}>
                                    <td className="text-center">{idx+1}</td>
                                    <td>{s.squad_name}</td>
                                    <td className="text-center">{s.squad_year}</td>
                                    <td className="text-center">
                                        <div className="btn-group" role="group">
                                          <button 
                                            className="btn btn-outline-primary btn-sm"
                                            data-bs-toggle="modal"
                                            data-bs-target="#editModalPop"
                                            onClick={() => handleEditSquad(s,idx)}
                                            title="Edit Squad"
                                          >
                                            <i className="fa fa-pencil"></i>
                                          </button>
                                          <button 
                                            onClick={() => deleteSquad(s._id,idx)}
                                            className="btn btn-outline-danger btn-sm"
                                            title="Delete Squad"
                                          >
                                            <i className="fa fa-trash"></i>
                                          </button>
                                        </div>
                                    </td>
                                </tr>)
                                :
                                <tr>
                                    <td colSpan={4} className="text-center text-muted py-4">
                                      <i className="fa fa-users fa-2x mb-2 d-block text-muted"></i>
                                      No squad found
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
        </div>
        <div className="modal fade" data-bs-backdrop="static" data-bs-keyboard="false"  id="editModalPop">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="staticBackdropLabel">Edit Squad</h5>
                                    <button 
                                        type="button" 
                                        className="btn-close" 
                                        data-bs-dismiss="modal" 
                                        //onClick={() => handleReset()} 
                                        aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    {
                                        status ? 
                                            <div className="container">
                                                <div className="row my-3">
                                                    <div className="col-md-12 col-sm-12 d-flex flex-column justify-content-center border-1">
                                                         <div className="success-img"></div>
                                                        <h4 className="text-success text-center m-3">Row Updated Successfully !!!</h4>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="container">
                                            <div className="row my-3">
                                                <div className="col-md-12 col-sm-12">
                                                    <label htmlFor="squad_name" className="small"><strong>Squad</strong></label>
                                                    <input 
                                                        type="text"
                                                        className='form-control service'
                                                        name="squad_name"
                                                        value={squadName}
                                                        onChange={e => handleSquadChange(e)}
                                                        autoComplete='off'
                                                        id="squad_name" />
                                                </div>  
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12">
                                                    <label htmlFor="squad_year" className="small"><strong>Year</strong></label>
                                                    <input
                                                        name="squad_year"
                                                        className='form-control service'
                                                        id="squad_year"
                                                        value={squadYear}
                                                        autoComplete='off'
                                                        onChange = {e => handleSquadChange(e)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                   
                                </div>
                                <div className="modal-footer">
                                    {/* <button 
                                        type="button" 
                                        className="btn btn-secondary"
                                        onClick={() => handleReset()} 
                                        data-bs-dismiss="modal">Close</button> */}
                                    {
                                        status ? 
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary"
                                            //onClick={() => handleReset()} 
                                            data-bs-dismiss="modal">Close</button>
                                        :
                                        <button 
                                            onClick={() => handleUpdateSquad()}
                                            type="button" 
                                            className="btn btn-primary">Update</button>
                                    }
                                    
                                </div>
                            </div>
                        </div>
             
        </div>
        <ToastContainer/>
    </div>
  )
}

export default SquadComponent